import React from 'react';
import moment from 'moment';
import { Grid, Link } from '@material-ui/core';
import { Paper, Text } from 'library';

export default function InstantAvailabilitySlot({
    booking,
    onBook,
}: {
    booking: { start_date: Date; end_date: Date };
    onBook: (b: { start_date: Date; end_date: Date }) => void;
}) {
    return (
        <Link onClick={() => onBook(booking)}>
            <Paper style={{ marginBottom: 12 }}>
                <Grid container direction="column">
                    <Text variant="body2">
                        {moment(booking.start_date).format('dd M/D ha')}-{moment(booking.end_date).format('ha')}
                    </Text>
                </Grid>
            </Paper>
        </Link>
    );
}
